import {
  XSD_BOOLEAN_IRI,
  XSD_DATE_TIME_IRI,
  XSD_STRING_IRI,
  XSD_TIME_IRI,
} from 'bones/constants/iris';
import {
  DATE_SPLIT_SYMBOL,
  DatatypeOperatorType,
  DatatypeOperatorTypeValue,
  DatatypeRange,
} from 'bones/utils/queryBuilder/constants';

export const DEFAULT_BOOLEAN_VALUE = 'false';
export const DEFAULT_TIME_VALUE = '00:00:00';
export const DEFAULT_TIME_RANGE_VALUE = `${DEFAULT_TIME_VALUE}${DATE_SPLIT_SYMBOL}${DEFAULT_TIME_VALUE}`;

export const getValueForNewOperator = ({
  range,
  operatorType,
  prevOperatorType,
  value,
}: {
  operatorType: DatatypeOperatorTypeValue;
  prevOperatorType?: DatatypeOperatorTypeValue;
  range: DatatypeRange;
  value: string | null;
}) => {
  let newValue: string | null = value;
  const isPlural = operatorType === DatatypeOperatorType.BETWEEN;
  const wasPlural = prevOperatorType === DatatypeOperatorType.BETWEEN;

  // provide default for unknown or string or exists
  if (
    value === null &&
    (range === null ||
      range === XSD_STRING_IRI ||
      operatorType === DatatypeOperatorType.EXISTS ||
      operatorType === DatatypeOperatorType.DOES_NOT_EXIST)
  ) {
    newValue = '';
  }
  // provide default for boolean
  else if (
    range === XSD_BOOLEAN_IRI &&
    operatorType === DatatypeOperatorType.IS
  ) {
    newValue = DEFAULT_BOOLEAN_VALUE;
  }
  // time always shows with a value
  else if (range === XSD_TIME_IRI) {
    if (!isPlural && (!value || wasPlural)) {
      newValue = DEFAULT_TIME_VALUE;
    } else if (isPlural && (!value || !wasPlural)) {
      newValue = DEFAULT_TIME_RANGE_VALUE;
    }
  }
  // but dates can be in a state with no selection
  else if (
    range === XSD_DATE_TIME_IRI &&
    ((isPlural && !wasPlural) || (!isPlural && wasPlural))
  ) {
    newValue = null;
  }

  return newValue;
};
